export default __webpack_public_path__ + "static/media/bro.488e97d3.png";